import { render } from "./TcodeComponent.vue?vue&type=template&id=bbcb1534"
import script from "./TcodeComponent.vue?vue&type=script&lang=js"
export * from "./TcodeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__